<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('COMPANYNAME')">
            <inputvalidation :formerror="formError" name="companyName"><b-form-input type="text" v-model="formData.companyName" v-bind:placeholder="$t('COMPANYNAME')"></b-form-input></inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('COMPANYADRESS')">
            <inputvalidation :formerror="formError" name="companyAdress"><b-form-input type="text" v-model="formData.companyAdress" v-bind:placeholder="$t('COMPANYADRESS')"></b-form-input></inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('COMAPNYADDRESSNUMBER')">
            <inputvalidation :formerror="formError" name="comapnyAddressNumber"><b-form-input type="text" v-model="formData.comapnyAddressNumber" v-bind:placeholder="$t('COMAPNYADDRESSNUMBER')"></b-form-input></inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('COMPANYCITY')">
            <inputvalidation :formerror="formError" name="companyCity"><b-form-input type="text" v-model="formData.companyCity" v-bind:placeholder="$t('COMPANYCITY')"></b-form-input></inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('COMPANYOIB')">
            <inputvalidation :formerror="formError" name="companyOib"><b-form-input type="text" v-model="formData.companyOib" v-bind:placeholder="$t('COMPANYOIB')"></b-form-input></inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('COMPANYTYPE')">
            <inputvalidation :formerror="formError" name="companyTypeId">
                <lb-vue-select v-model= "formData.companyTypeId"
                            :list= "companyTypeData.root"
                            display-field= "name"
                            value-field= "companyTypeId">
                </lb-vue-select>
            </inputvalidation>
        </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('COMPANYLOGO')">
            <fileupload v-model="formData.file" :chooseLabel="$t('COMPANYLOGO')" />
        </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
    name: 'UserCompanyForm',
    props: ['formData', 'formError', 'companyTypeData'],
};
</script>
